import routes, { IRoutes } from './routes';
import { Route } from 'react-router-dom';
import LoadingScreen from './LoadingScreen';
import { Suspense } from 'react';
import Authorization from '../Authorization';

export default function renderRoutes() {
  const renderedRoutes = routes.map((route: IRoutes) => {
    const Component = route.component;
    const path = route.path;

    return (
      <Route
        key={`route-${route.id}`}
        path={path}
        element={
          <Authorization>
            <Suspense fallback={<LoadingScreen />}>
              <Component />
            </Suspense>
          </Authorization>
        }
      />
    );
  });

  return renderedRoutes;
}
